import { connect } from 'react-redux';
import React, { Component } from 'react';

import MenuBar from './MenuBar';
import SideBar from './SideBar';
import TreeNavBar from './TreeNavBar';
import SnackBar from './SnackBar';
import Tooltip from './Tooltip';
import ApiContent from './ApiContent';

import {colors, darkBaseTheme, lightBaseTheme, getMuiTheme} from 'material-ui/styles';
const {white, grey200, blueGrey200, blueGrey400, blueGrey600, indigo200, indigo400, indigo600} = colors;

import _ from 'lodash';

class App extends Component {
  componentWillMount() {
    this.props.onRouteUpdate(this.getSelected(this.props));
  }

  componentWillReceiveProps(nextProps) {
    this.props.onRouteUpdate(this.getSelected(nextProps));
  }

  getChildContext() {
    const dark = false;
    const raw = dark ? darkBaseTheme : lightBaseTheme;
    _.assign(raw.palette, {
      primary1Color: blueGrey200,
      primary2Color: blueGrey400,
      primary3Color: blueGrey600,
      canvasColor: grey200,
      accent1Color: indigo200,
      accent2Color: indigo400,
      accent3Color: indigo600
    });
    // raw.fontFamily = 'monospace'; //raw.fontFamily = 'ubuntu mono';
    raw.fontWeight = 'bolder';

    const theme = getMuiTheme(raw);
    theme.tableHeader.height = 30;
    theme.tableHeaderColumn.height = 30;
    theme.tableRow.height = 30;
    theme.tableRowColumn.height = 30;
    theme.listItem.nestedLevelDepth = 10;
    theme.menuItem.height = 32;
    theme.menuItem.padding = 0;
    theme.spacing.desktopDropDownMenuItemHeight = 24;

    return {
      muiTheme: theme
    };
  }

  getSelected(props) {
    // destructure React Router properties
    const {location: params} = props;
    const [api, ...route] = params.pathname.split('/').filter(part => part.length > 0);
    const [skip, method] = params.hash.split('#');

    return {
      api,
      route: route.join('/'),
      method
    };
  }

  render() {
    return (
      <div style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%'}}>
        <MenuBar/>
        <div className="right-api-div">
          <ApiContent/>
        </div>
        <TreeNavBar/>
        <SnackBar/>
        <Tooltip/>
      </div>
    );
  }
}

App.childContextTypes = {
  muiTheme: React.PropTypes.object
};

export default connect(
  state => ({}),
  dispatch => ({
    onRouteUpdate(data) {
      dispatch({type: 'ROUTE_UPDATE', data});
    }
  })
)(App);
